export const iconFontAwesomeBuildingsHospitalUser = (
	<i className="fa-solid fa-hospital-user"></i>
);
